import { useAppBridge } from '@shopify/app-bridge-react';
import { Card, Page, Toast } from '@shopify/polaris';
import { ComponentProps, useLayoutEffect } from 'react';
import useMainStore from '../store/useMainStore';
import { useShallow } from 'zustand/shallow';
import { Fragment } from 'react';

type IProps = Pick<ComponentProps<'div'>, 'children'>;

const FixLoading = ({ children }: IProps) => {
    const app = useAppBridge();
    const { toast, setToast } = useMainStore(
        useShallow((state) => ({
            toast: state.toast,
            setToast: state.setToast,
        })),
    );

    useLayoutEffect(() => {
        // POS embedded app started to get into an infinite loading state in Android
        // https://community.shopify.dev/t/embedded-pos-app-gets-into-an-infinite-loading-state-when-navigating/11508/15
        app.loading(true);
        app.loading(false);
    }, [app]);

    const closeToast = () => setToast(null);

    const toastMarkup = toast ? <Toast onDismiss={closeToast} duration={5000} {...toast} /> : null;

    return (
        <Fragment>
            <Page narrowWidth>
                <Card roundedAbove="sm">{children}</Card>
            </Page>
            {toastMarkup}
        </Fragment>
    );
};

export default FixLoading;
